// Detects whether a CSS rule from a (possibly deferred) stylesheet is applied
// by probing the computed style of a hidden node. Scanning document.styleSheets
// is not an option: production CSS is served cross-origin (CDN), so cssRules
// throws a SecurityError. Positive results are cached - applied stylesheets do
// not unload.
const appliedCache = {}

const isCssApplied = (className, property, expectedValue) => {
  const cacheKey = `${className}|${property}|${expectedValue}`

  if (appliedCache[cacheKey]) {
    return true
  }

  if (typeof document === 'undefined' || !document.body) {
    return false
  }

  const probe = document.createElement('div')
  probe.className = className
  probe.style.display = 'none'
  document.body.appendChild(probe)
  const applied = window.getComputedStyle(probe)[property] === expectedValue
  document.body.removeChild(probe)

  if (applied) {
    appliedCache[cacheKey] = true
  }

  return applied
}

export default isCssApplied
